const chromelessRoutes = [
  'checkout',
  'onboarding',
  'plans',
  'quiz',
  'redeem',
  'restricted',
  'signin',
  'tab-viewer',
];

function isChromelessRoute(routeStr) {
  let isChromeless = false;
  if (routeStr) {
    const playSplit = routeStr.split('/play/');
    const afterPlay = playSplit.length > 1 ? playSplit[1] : playSplit[0];
    const slashSplit = afterPlay.split('/');
    const rootPath = slashSplit[0] === '' ? slashSplit[1] : slashSplit[0];
    chromelessRoutes.forEach(str => {
      if (rootPath === str) {
        isChromeless = true;
      }
    });
  }
  return isChromeless;
}

export { chromelessRoutes, isChromelessRoute };
